// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eL","menuControls_styleDefault":"c-a_eM","menuControls_styleRed":"c-a_eN"};